/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { lazyNamedRoute } from './lazyRoute';
import { type NavigationRoute } from './navigationRoute';

export const articleRoutes: NavigationRoute[] = [
    {
        path: '/articles',
        lazy: lazyNamedRoute(
            () => import('../../src/containers/articles/ArticlesPage'),
            'ArticlesPage'
        ),
    },
    {
        path: '/articles/:contentType/:title/:id',
        lazy: lazyNamedRoute(
            () => import('../../src/containers/articles/ArticlePage'),
            'ArticlePage'
        ),
    },
];
